<div [class.full-width]="isFullWidth" [class.open]="isMenuOpen" class="sidenav">
    <div *appInjectFilter="currentFilter$ | async"></div>
</div>
